<mat-chip-list selectable multiple [disabled]="disabled">
    <mat-chip #c="matChip" *ngFor="let option of options" (click)="toggleSelection(c)" [value]="option.id"
        [disabled]="disabled" [selected]="activeOptions?.includes(option.id)">
        <mat-icon *ngIf="c.selected">check</mat-icon>
        {{option.name}}
    </mat-chip>
</mat-chip-list>